module.exports = __webpack_public_path__ + "assets/img/news (26).483e5bc0.png";